<template>
    <div class="de-simple-rank" :style="{'background': backColor}">
        <div class="wrapper" :style="wrapperStyle" v-for="(item, index) in listData" :key="index">
            <span class="index" v-if="showIndex" :style="indexStyle">{{index < 9 ? `0${index+1}` : index+1}}</span>
            <span class="name">{{item.name}}</span>
            <span class="bar-wrapper">
                <bar class="bar" 
                :style="barStyle" 
                :value="item.percent || item.total" 
                :color="color" 
                :maxValue="max" 
                :backgroundColor="'rgba(0,145,255,0.18)'"
                :barStyle="innerBar"></bar>
            </span>
            <span class="percent" :style="percentStyle" v-if="showPercent && item.percent && item.percent!=0">{{item.percent}}%</span>
            <span class="total" :style="totalStyle" v-if="showTotal && item.total && item.total!=0 && !isFormat">{{item.total}}</span>
            <span class="total" :style="totalStyle" v-if="showTotal && item.total && item.total!=0 && isFormat">{{item.total | formatAmount}}</span>
        </div>
    </div>
</template>

<script>
import bar from '../../rank/rank/yBar';

export default {
    name: 'de-simple-rank',
    components: {
        bar
    },
    props: {
        isFormat: {
            type: Boolean,
            default: true
        },
        customWidth: {
            type: Number
        },
        showIndex: {
            type: Boolean,
            default: true
        },
        showPercent: {
            type: Boolean,
            default: true
        },
        showTotal: {
            type: Boolean,
            default: true
        },
        length: {
            type: Number,
            default: 10
        },
        data: {
            type: [Array, Object],
            default: () => {
                return [{
                    name: '北京市',
                    percent: 56,
                    total: 5645654
                }]
            }
        },
        fontObj: {
            type: Object
        },
        padding: {
            type: Number,
            default: 10
        },
        margin: {
            type: Number,
            default: 12
        },
        color: {
            type: String,
            default: 'linear-gradient(-45deg, #038CFB 0%, #102FA8 100%)'
        },
        borderRadius: {
            type: Number,
            default: 0
        },
        backColor: {
            type: String
        }
    },
    watch: {
        data: {
            handler(v) {
                if (v) {
                    if (v.length > this.length) {
                        this.listData = v.slice(0, this.length);
                    } else {
                        this.listData = v.concat([]);
                    }
                }
            },
            deep: true,
            immediate: true
        },
        length(v) {
            if (v) {
                this.listData = this.data.slice(0, v);
            }
        }
    },
    computed: {
        wrapperStyle() {
            return this.fontObj && this.margin
            ? Object.assign({}, this.fontObj, {
                fontSize: `${this.fontObj.fontSize}px`,
                fontStyle: `${this.fontObj.fontStyle}`,
                color: `${this.fontObj.color}`,
                marginTop: `${this.margin}px`,
            })
            : {}
        },
        indexStyle() {
            return this.fontObj
            ? Object.assign({}, {
                width: `${this.fontObj.fontSize*2}px`,
                height: `${this.fontObj.fontSize*2}px`,
                marginRight: `${this.padding}px`,
                lineHeight: `${this.fontObj.fontSize*2}px`,
            })
            : {}
        },
        percentStyle() {
            return this.fontObj && this.padding
            ? Object.assign({}, {
                paddingLeft: `${this.padding}px`
            })
            : {}
        },
        totalStyle() {
            return this.fontObj && this.padding
            ? Object.assign({}, {
                paddingLeft: `${this.padding}px`
            })
            : {}
        },
        barStyle() {
            return this.fontObj && this.padding && this.margin
            ? Object.assign({}, {
                width: '100%',
                height: `${this.fontObj.fontSize-2}px`,
                marginLeft: `${this.padding}px`,
                marginTop: `4px`,
                boxShadow: `inset 2px 4px 20px 0 rgba(255,255,255,0.10)`,
                borderRadius: `${this.borderRadius}px`,
            })
            : {
                boxShadow: `inset 2px 4px 20px 0 rgba(255,255,255,0.10)`
            }
        },
        innerBar() {
            return this.borderRadius
            ? Object.assign({}, {
                height: `${this.fontObj.fontSize-2}px`,
                borderRadius: `${this.borderRadius}px`,
            })
            : {}
        },
        max() {
            let max;
            this.listData && this.listData.forEach(item => {
                let percent = item.percent ? Number(item.percent) : Number(item.total);
                if (!max) {
                    max = percent;
                } else if (max < percent) {
                    max = percent;
                }
            });
            return max + 3;
        },
    },
    data() {
        return {
            listData: null,
        }
    }
}
</script>

<style lang="less">
.de-simple-rank {
    .wrapper {
        display: flex;
        font-size: 12px;
        color: #FFFFFF;
        .index {
            display: inline-block;
            border: 1px solid rgba(3,140,251,0.60);
            border-radius: 4px;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            color: rgba(255,255,255,0.75);
        }
        .name {
            display: inline-block;
            flex: 1.5;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            vertical-align: middle;
        }
        .bar-wrapper {
            display: inline-block;
            flex: 3;
            .bar {
                width: 100%;
            }
        }
        .total, .percent {
            flex: 1;
            text-align: right;
            font-family: 'AgencyFB-Reg';
        }
    }
}
</style>